module.exports = {"pagination":{"DescribeBatchPredictions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/machinelearning-2014-12-12.paginators.json
// module id = 771
// module chunks = 1